export const INSIGHTS_EVENT_TYPES = Object.freeze([
  { value: "ENGULFING", label: "ENGULFING" },
  { value: "RSI DIV", label: "RSI DIV" },
  { value: "ORDER BLOCK VISIT", label: "ORDER BLOCK VISIT" },
  { value: "EXTREMUM VISIT", label: "EXTREMUM VISIT" },
  { value: "REVERSAL", label: "REVERSAL" },
  { value: "GRAB", label: "GRAB" },
  { value: "GOLDEN POCKET", label: "GOLDEN POCKET" },
  { value: "PA MA CROSS", label: "PA MA CROSS" },
  { value: "BELOW 1W BB", label: "BELOW 1W BB" },
  { value: "MOVE INTO BB", label: "MOVE INTO BB" },
  { value: "MA WITHIN NARROW BB", label: "MA WITHIN NARROW BB" },
  { value: "TINY-HUGE", label: "TINY-HUGE" },
  { value: "MA AND BB BBD", label: "MA AND BB (Bollinger Dominance)" },
  { value: "MA AND BB MAD", label: "MA AND BB (MA Dominance)" },
  { value: "15M-4H", label: "15M-4H" },
  { value: "4H-1D", label: "4H-1D" },
  { value: "15M-4H-1D", label: "15M-4H-1D" },
].map((entry) => Object.freeze(entry)));

export const EVENT_EVALUATION_TIMEFRAMES = Object.freeze(["15M", "4H", "1D"]);

export const EVENT_CAPTURE_TIMEFRAMES = Object.freeze({
  "15M": Object.freeze(["15M", "4H"]),
  "4H": Object.freeze(["4H", "1D"]),
  "1D": Object.freeze(["1D"]),
});
